import { render, staticRenderFns } from "./CuratedInvitationList.vue?vue&type=template&id=72a68f47&scoped=true"
import script from "./CuratedInvitationList.vue?vue&type=script&lang=js"
export * from "./CuratedInvitationList.vue?vue&type=script&lang=js"
import style0 from "./CuratedInvitationList.vue?vue&type=style&index=0&id=72a68f47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a68f47",
  null
  
)

export default component.exports